module.exports = __webpack_public_path__ + "static/media/15-Hannover@2x.8fa54967.jpg";